"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIVENESS_BIOMETRIC_FIELD_MAP = exports.BIOMETRIC_FIELD_PATTERN = exports.BIOMETRIC_ENTRY_CANDIDATE_KEYS = void 0;
exports.buildBiometricValidationHighlights = buildBiometricValidationHighlights;
exports.extractBiometricEntriesFromPayload = extractBiometricEntriesFromPayload;
exports.findBiometricValueByAliases = findBiometricValueByAliases;
exports.formatBiometricProcessingStatus = formatBiometricProcessingStatus;
exports.getBiometricToneByValue = getBiometricToneByValue;
exports.getDefaultBiometricTag = getDefaultBiometricTag;
exports.normalizeBiometricEntry = normalizeBiometricEntry;
exports.normalizeBiometricKey = normalizeBiometricKey;
exports.parseBiometricBooleanStatus = parseBiometricBooleanStatus;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var BIOMETRIC_ENTRY_CANDIDATE_KEYS = exports.BIOMETRIC_ENTRY_CANDIDATE_KEYS = ['validationFacetec', 'validationBiometric', 'validationSelfieValidation', 'validationSelfieValidations', 'validationSelfieChecks', 'validationSelfieResult', 'validationSelfieResults', 'validationFaceResult', 'validationFaceResults'];
var BIOMETRIC_FIELD_PATTERN = exports.BIOMETRIC_FIELD_PATTERN = /match-3d-3d|enrollment-3d|face-scan|replay|session-token|audit-trail|was-processed|sucess|success/i;
var LIVENESS_BIOMETRIC_FIELD_MAP = exports.LIVENESS_BIOMETRIC_FIELD_MAP = [{
  key: 'final-result',
  label: 'Resultado final da validação biométrica',
  icon: 'check-decagram',
  aliases: ['in-sucess-match-3d-3d', 'in-success-match-3d-3d', 'in-sucess-enrollment-3d', 'in-success-enrollment-3d', 'success'],
  approvedText: 'Aprovado',
  rejectedText: 'Reprovado',
  approvedTag: 'Aprovado',
  rejectedTag: 'Reprovado',
  helper: 'Consolida a decisão final retornada na validação biométrica.'
}, {
  key: 'processed',
  label: 'Indica se o processamento biométrico foi concluído corretamente',
  icon: 'cog',
  aliases: ['in-was-processed-match-3d-3d', 'in-was-processed-enrollment-3d', 'wasProcessed'],
  approvedText: 'Concluído corretamente',
  rejectedText: 'Não concluído',
  approvedTag: 'Sucesso',
  rejectedTag: 'Falha',
  helper: 'Mostra se o fluxo biométrico foi processado até o fim sem inconsistências.'
}, {
  key: 'liveness',
  label: 'Resultado da análise de Liveness / Anti Spoofing',
  icon: 'shield-check',
  aliases: ['in-audit-trail-verification-match-3d-3d', 'in-audit-Trail-verification-match-3d-3d', 'in-audit-trail-verification-enrollment-3d', 'in-audit-trail-verification-match-3d', 'in-audit-trail-verification-enrollment-3d-3d', 'auditTrailVerificationSucceeded'],
  approvedText: 'Validado',
  rejectedText: 'Não Validado',
  approvedTag: 'Validado',
  rejectedTag: 'Alerta',
  helper: 'Resume o resultado da prova de vida e da proteção contra tentativa de fraude.'
}, {
  key: 'facematch',
  label: 'Resultado da validação facial FaceMatch',
  icon: 'account-check',
  aliases: ['in-face-scan-match-3d-3d', 'in-face-scan-enrollment-3d', 'faceScanSucceeded'],
  approvedText: 'Sucesso',
  rejectedText: 'Falha',
  approvedTag: 'Sucesso',
  rejectedTag: 'Falha',
  helper: 'Indica se a biometria facial corresponde ao cadastro esperado.'
}, {
  key: 'replay',
  label: 'Verificação de reutilização de biometria/binário',
  icon: 'autorenew',
  aliases: ['in-replay-match-3d-3d', 'in-replay-enrollment-3d', 'replayCheckSucceeded'],
  approvedText: 'Não identificado replay',
  rejectedText: 'Replay detectado',
  approvedTag: 'Seguro',
  rejectedTag: 'Crítico',
  helper: 'Aponta se houve indício de reaproveitamento indevido da biometria capturada.'
}, {
  key: 'session-token',
  label: 'Validação de segurança da sessão/origem da requisição',
  icon: 'key',
  aliases: ['in-session-token-match-3d-3d', 'in-session-token-enrollment-3d', 'sessionTokenCheckSucceeded'],
  approvedText: 'Sessão válida',
  rejectedText: 'Sessão inválida',
  approvedTag: 'Validado',
  rejectedTag: 'Falha',
  helper: 'Confirma a integridade da sessão e a origem da requisição biométrica.'
}];
function normalizeBiometricKey(value) {
  return String(value || '').trim().replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase().replace(/_/g, '-');
}
function parseBiometricBooleanStatus(value) {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
  }
  if (typeof value === 'string') {
    var normalized = value.trim().toLowerCase();
    if (['true', '1', 'approved', 'aprovado', 'validado', 'success', 'sucesso'].includes(normalized)) {
      return true;
    }
    if (['false', '0', 'disapproved', 'reprovado', 'falha', 'error', 'erro', 'failed'].includes(normalized)) {
      return false;
    }
  }
  return null;
}
function formatBiometricProcessingStatus(value) {
  if (!value) {
    return '';
  }
  var normalized = String(value).trim().toLowerCase();
  if (['concluido', 'concluído', 'completed'].includes(normalized)) {
    return 'Concluído';
  }
  if (['processing', 'processando', 'pending', 'pendente'].includes(normalized)) {
    return 'Em análise';
  }
  if (['error', 'erro', 'failed', 'falha'].includes(normalized)) {
    return 'Falha';
  }
  return String(value);
}
function getBiometricToneByValue(parsedValue) {
  if (parsedValue === true) {
    return 'success';
  }
  if (parsedValue === false) {
    return 'danger';
  }
  return 'warning';
}
function getDefaultBiometricTag(tone) {
  switch (tone) {
    case 'success':
      return 'Aprovado';
    case 'danger':
      return 'Falha';
    default:
      return 'Em análise';
  }
}
function findBiometricValueByAliases(biometricMap) {
  var aliases = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return aliases.reduce(function (result, alias) {
    if (result !== null && result !== undefined && result !== '') {
      return result;
    }
    var value = biometricMap[normalizeBiometricKey(alias)];
    return value !== undefined ? value : result;
  }, null);
}
function buildBiometricValidationHighlights(biometricMap) {
  return LIVENESS_BIOMETRIC_FIELD_MAP.map(function (item) {
    var rawValue = findBiometricValueByAliases(biometricMap, item.aliases);
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return null;
    }
    var parsedValue = parseBiometricBooleanStatus(rawValue);
    var tone = getBiometricToneByValue(parsedValue);
    return {
      key: item.key,
      kind: 'boolean',
      label: item.label,
      icon: item.icon,
      helper: item.helper,
      tone: tone,
      tag: parsedValue === null ? 'Em análise' : parsedValue ? item.approvedTag : item.rejectedTag,
      text: parsedValue === null ? 'Status indisponível' : parsedValue ? item.approvedText : item.rejectedText,
      rawValue: rawValue,
      aliases: item.aliases[0]
    };
  }).filter(Boolean);
}
function isPrimitiveBiometricValue(value) {
  return ['boolean', 'number', 'string'].includes(_typeof(value));
}
function extractPrimitiveFromObjectValue(value) {
  if (!value || _typeof(value) !== 'object') {
    return undefined;
  }
  var candidates = [value === null || value === void 0 ? void 0 : value.valor, value === null || value === void 0 ? void 0 : value.value, value === null || value === void 0 ? void 0 : value.status, value === null || value === void 0 ? void 0 : value.result, value === null || value === void 0 ? void 0 : value.response, value === null || value === void 0 ? void 0 : value.output];
  return candidates.find(function (candidate) {
    return isPrimitiveBiometricValue(candidate);
  });
}
function hasStructuredBiometricEntryKeys() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keyCandidate = (item === null || item === void 0 ? void 0 : item.nome) || (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.key) || (item === null || item === void 0 ? void 0 : item.field) || (item === null || item === void 0 ? void 0 : item.parameter);
  var valueCandidate = (item === null || item === void 0 ? void 0 : item.valor) !== undefined ? item.valor : (item === null || item === void 0 ? void 0 : item.value) !== undefined ? item.value : (item === null || item === void 0 ? void 0 : item.status) !== undefined ? item.status : item === null || item === void 0 ? void 0 : item.result;
  return Boolean(keyCandidate) && isPrimitiveBiometricValue(valueCandidate);
}
function normalizeBiometricEntry(item) {
  if (!item || _typeof(item) !== 'object') {
    return null;
  }
  var nome = item.nome || item.name || item.key || item.field || item.parameter;
  var valor = item.valor !== undefined ? item.valor : item.value !== undefined ? item.value : item.status !== undefined ? item.status : item.result;
  if (!nome || !isPrimitiveBiometricValue(valor)) {
    return null;
  }
  return {
    nome: nome,
    valor: valor
  };
}
function extractBiometricEntriesFromPayload() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var entries = [];
  var visited = new WeakSet();
  var _visit = function visit(target) {
    if (!target || _typeof(target) !== 'object') {
      return;
    }
    if (visited.has(target)) {
      return;
    }
    visited.add(target);
    if (Array.isArray(target)) {
      target.forEach(function (item) {
        if (hasStructuredBiometricEntryKeys(item)) {
          var normalizedEntry = normalizeBiometricEntry(item);
          if (normalizedEntry) {
            entries.push(normalizedEntry);
          }
          return;
        }
        _visit(item);
      });
      return;
    }
    Object.entries(target).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      var normalizedKey = normalizeBiometricKey(key);
      if (isPrimitiveBiometricValue(value) && (normalizedKey === 'status' || BIOMETRIC_FIELD_PATTERN.test(normalizedKey))) {
        entries.push({
          nome: key,
          valor: value
        });
        return;
      }
      if (normalizedKey === 'status' || BIOMETRIC_FIELD_PATTERN.test(normalizedKey)) {
        var primitiveValue = extractPrimitiveFromObjectValue(value);
        if (primitiveValue !== undefined) {
          entries.push({
            nome: key,
            valor: primitiveValue
          });
          return;
        }
      }
      if (Array.isArray(value) || value && _typeof(value) === 'object') {
        _visit(value);
      }
    });
  };
  BIOMETRIC_ENTRY_CANDIDATE_KEYS.forEach(function (key) {
    var candidate = data === null || data === void 0 ? void 0 : data[key];
    if (candidate) {
      _visit(candidate);
    }
  });
  _visit(data);
  return entries.filter(function (item) {
    return item === null || item === void 0 ? void 0 : item.nome;
  });
}